<template>
  <div class="music-search-container">
    <v-card style="background-color: black;" class="pb-0 ma-0 pa-0 pb-2">
      <v-text-field v-model="searchQuery" placeholder="Search in Muzible library.. [disabled]" density="compact" hide-details clearable
        class="custom-placeholder-color pa-6 pb-2" disabled color="#ffffff" base-color="white" variant="outlined" bg-color="black">
        <v-icon slot="append" color="white" class="pr-2">
          mdi-magnify
        </v-icon>
      </v-text-field>
    <span @click="showFilter = !showFilter" class="search-title pa-0 ma-0 pl-6" color="white">Filter</span>
        <v-expand-transition>
          <v-card v-if="showFilter" class="pa-0 ma-0" style="
              background-color: black!important;
              position:relative;
              width: 100vw !important;
            ">
            <v-card-item class="pa-0 ma-0">
              <Transition name="fade2">
                  <v-row class="pa-2 ma-0 pt-0 pb-0" justify="center" v-show="showFilter">
                    <v-col cols="12" class="pa-2 ma-0 pt-0 pl-4 pb-0" align="start">
                      <v-chip-group v-model="filter" multiple column @update:modelValue="handleFilterChange">
                      <v-chip value="all" class="chip-style" label>All</v-chip>
                      <v-chip value="atmos" class="chip-style" label>Dolby Atmos</v-chip>
                      <v-chip value="flac" class="chip-style" label>Flac/Alac Lossless</v-chip>
                      <v-chip value="ai" class="chip-style" label>AI Music</v-chip>
                      <v-chip value="ai_mood" class="chip-style" label>AI Music from Image</v-chip>
                      <v-chip value="nft_store" class="chip-style-nft" label>NFT Store</v-chip>
                      <v-chip value="nft_bonus" class="chip-style-nft" label>NFT Bonus</v-chip>
                      <v-chip value="nft_geo" class="chip-style-nft" label>NFT Geo</v-chip>
                      </v-chip-group>
                    </v-col>
                  </v-row>
              </Transition>
            </v-card-item>
          </v-card>
        </v-expand-transition>
    </v-card>
    <Transition name="fade2">
          <div v-show="isSearchLoading" class="loading-spinner pt-8">
            <v-progress-circular indeterminate color="white"></v-progress-circular>
          </div>
    </Transition>
    <Transition name="fade2">
      <div v-if="!isSearchLoading" :class="{'content-container2': this.showFilter && !isMobileXs && !isMobileSearch1 && !isMobileSearch2 && !isMobilePlayer3, 
                                            'content-container4': this.showFilter && !isMobileXs && isMobileSearch1 && !isMobileSearch2 && !isMobilePlayer3,
                                            'content-container1': this.showFilter && isMobileXs && !isMobileSearch2 && !isMobilePlayer3, 
                                            'content-container3': this.showFilter && isMobileXs && isMobileSearch2 && !isMobilePlayer3,

                                            'content-container2-mobile': this.showFilter && !isMobileXs && !isMobileSearch1 && !isMobileSearch2 && isMobilePlayer3, 
                                            'content-container4-mobile': this.showFilter && !isMobileXs && isMobileSearch1 && !isMobileSearch2 && isMobilePlayer3,
                                            'content-container1-mobile': this.showFilter && isMobileXs && !isMobileSearch2 && isMobilePlayer3, 
                                            'content-container3-mobile': this.showFilter && isMobileXs && isMobileSearch2 && isMobilePlayer3,

                                            'content-container': this.showFilter === false && !isMobilePlayer3,
                                            'content-container-mobile': this.showFilter === false && isMobilePlayer3, 'pa-2 pt-0': true}">
        <div v-if="isMobileXs">
          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">Music
                <a :href="'https://muze.muzible.com/search/music?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <div v-if="userSearchResults.songs && userSearchResults.songs.length > 0" class="pa-0 ma-0" justify="start">
            <v-row class="pa-2 ma-0" v-for="mus in userSearchResults.songs" :key="mus.id">
              <v-col cols="2" class="pa-0 ma-0">
                <v-hover>
                  <template v-slot:default="{ isHovering, props }">
                    <div v-bind="props" class="pa-0 ma-0">
                      <v-img :src="mus.art" @click="this.playOrPauseSong(mus)" class="album-art-row" contain cover max-height="60px" max-width="60px">
                        <v-icon v-if="
                          isHovering &&
                          this.ifCurrentMusicNow(mus) &&
                          this.isPlayingNow(mus)
                        " class="overlay-icon" color="white" size="60px">mdi-pause</v-icon>
                        <v-icon v-if="
                          isHovering &&
                          this.ifCurrentMusicNow(mus) &&
                          !this.isPlayingNow(mus)
                        " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                        <v-icon v-if="
                          isHovering &&
                          !this.ifCurrentMusicNow(mus)
                        " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                        <v-icon v-if="
                          !isHovering &&
                          this.isPlayingNow(mus)
                        " class="music-icon" color="#1ff050" size="60px">mdi-music</v-icon>

                      </v-img>
                    </div>
                  </template>
                </v-hover>
              </v-col>
              <v-col cols="6" class="pa-0 ma-0 pl-5">
                <div class="track-info">
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 200px;
                            ">
                    <a v-if="mus.type === 'muze' && mus.album === ''" :href="'https://muze.muzible.com/track/' + mus.id"
                      class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'muze' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' + mus.id"
                      class="artist-link">{{
                      mus.title }}</a>
                    <a v-if="mus.type === 'geo'" :href="'https://verse.muzible.com/track/' + mus.id"
                      class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'global' && mus.album === ''" :href="'https://muze.muzible.com/track/' + mus.id"
                      class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'global' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album === ''"
                      :href="'https://muze.muzible.com/episode/' + mus.id" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album !== ''"
                      :href="'https://muze.muzible.com/podcast/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                  </div>
                  <div style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 200px;
                            ">
                    <span v-for="(artist, index) in mus.artists" :key="index">
                      <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist
                        }}</a>
                      <span v-if="index < mus.artists.length - 1">, </span>
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col cols="2" align="end" class="pa-0 ma-0">
                  <div class="track-info pt-4">
                    <span style="color: grey;">{{ mus.duration }}</span>
                  </div>
              </v-col>
              <v-col cols="2" align="end" class="pa-0 ma-0">
                <v-btn :disabled="userFavSongs.length > 149" v-if="this.notinFav(mus.id)" icon="mdi-star-outline"
                  class="pt-4" :ripple="false" density="compact" size="small" variant="plain"
                  style="color: white !important" @click="this.addToFav(mus)">
                </v-btn>
                <v-btn v-else icon="mdi-star" class="pt-4" :ripple="false" density="compact" size="small" variant="plain"
                  style="color: #f0e556 !important" @click="this.removeFromFav(mus)">
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>

          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">Podcasts
                <a :href="'https://muze.muzible.com/search/podcast?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <div v-if="userSearchResults.podcasts && userSearchResults.podcasts.length > 0" class="pa-0 ma-0" justify="start">
            <v-row class="pa-2 ma-0" v-for="mus in userSearchResults.podcasts" :key="mus.id">
              <v-col cols="2" class="pa-0 ma-0">
                <v-hover>
                  <template v-slot:default="{ isHovering, props }">
                    <div v-bind="props" class="pa-0 ma-0">
                      <v-img :src="mus.art" @click="this.playOrPauseSong(mus)" class="album-art-row" contain cover max-height="60px" max-width="60px">
                        <v-icon v-if="
                          isHovering &&
                          this.ifCurrentMusicNow(mus) &&
                          this.isPlayingNow(mus)
                        " class="overlay-icon" color="white" size="60px">mdi-pause</v-icon>
                        <v-icon v-if="
                          isHovering &&
                          this.ifCurrentMusicNow(mus) &&
                          !this.isPlayingNow(mus)
                        " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                        <v-icon v-if="
                          isHovering &&
                          !this.ifCurrentMusicNow(mus)
                        " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                        <v-icon v-if="
                          !isHovering &&
                          this.isPlayingNow(mus)
                        " class="music-icon" color="#1ff050" size="60px">mdi-music</v-icon>

                      </v-img>
                    </div>
                  </template>
                </v-hover>
              </v-col>
              <v-col cols="6" class="pa-0 ma-0 pl-5">
                <div class="track-info">
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 200px;
                            ">
                    <a v-if="mus.type === 'podcast' && mus.album === ''"
                      :href="'https://muze.muzible.com/episode/' + mus.id" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album !== ''"
                      :href="'https://muze.muzible.com/podcast/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                  </div>
                  <div style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 200px;
                            ">
                    <span v-for="(artist, index) in mus.artists" :key="index">
                      <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist
                        }}</a>
                      <span v-if="index < mus.artists.length - 1">, </span>
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col cols="2" align="end" class="pa-0 ma-0">
                  <div class="track-info pt-4">
                    <span style="color: grey;">{{ mus.duration }}</span>
                  </div>
              </v-col>
              <v-col cols="2" align="end" class="pa-0 ma-0">
                <v-btn :disabled="userFavSongs.length > 149" v-if="this.notinFav(mus.id)" icon="mdi-star-outline"
                  class="pt-4" :ripple="false" density="compact" size="small" variant="plain"
                  style="color: white !important" @click="this.addToFav(mus)">
                </v-btn>
                <v-btn v-else icon="mdi-star" class="pt-4" :ripple="false" density="compact" size="small" variant="plain"
                  style="color: #f0e556 !important" @click="this.removeFromFav(mus)">
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>

          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">Geo Music
                <a :href="'https://muze.muzible.com/search/geo?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <div v-if="userSearchResults.geo && userSearchResults.geo.length > 0" class="pa-0 ma-0" justify="start">
            <v-row class="pa-2 ma-0" v-for="mus in userSearchResults.geo" :key="mus.id">
              <v-col cols="2" class="pa-0 ma-0">
                <v-hover>
                  <template v-slot:default="{ isHovering, props }">
                    <div v-bind="props" class="pa-0 ma-0">
                      <v-img :src="mus.art" @click="this.playOrPauseSong(mus)" class="album-art-row" contain cover max-height="60px" max-width="60px">
                        <v-icon v-if="
                          isHovering &&
                          this.ifCurrentMusicNow(mus) &&
                          this.isPlayingNow(mus)
                        " class="overlay-icon" color="white" size="60px">mdi-pause</v-icon>
                        <v-icon v-if="
                          isHovering &&
                          this.ifCurrentMusicNow(mus) &&
                          !this.isPlayingNow(mus)
                        " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                        <v-icon v-if="
                          isHovering &&
                          !this.ifCurrentMusicNow(mus)
                        " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                        <v-icon v-if="
                          !isHovering &&
                          this.isPlayingNow(mus)
                        " class="music-icon" color="#1ff050" size="60px">mdi-music</v-icon>

                      </v-img>
                    </div>
                  </template>
                </v-hover>
              </v-col>
              <v-col cols="6" class="pa-0 ma-0 pl-5">
                <div class="track-info">
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 200px;
                            ">
                    <a v-if="mus.type === 'muze' && mus.album === ''" :href="'https://muze.muzible.com/track/' + mus.id"
                      class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'muze' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' + mus.id"
                      class="artist-link">{{
                      mus.title }}</a>
                    <a v-if="mus.type === 'geo'" :href="'https://verse.muzible.com/track/' + mus.id"
                      class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'global' && mus.album === ''" :href="'https://muze.muzible.com/track/' + mus.id"
                      class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'global' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album === ''"
                      :href="'https://muze.muzible.com/episode/' + mus.id" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album !== ''"
                      :href="'https://muze.muzible.com/podcast/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                  </div>
                  <div style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 200px;
                            ">
                    <span v-for="(artist, index) in mus.artists" :key="index">
                      <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist
                        }}</a>
                      <span v-if="index < mus.artists.length - 1">, </span>
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col cols="2" align="end" class="pa-0 ma-0">
                  <div class="track-info pt-4">
                    <span style="color: grey;">{{ mus.duration }}</span>
                  </div>
              </v-col>
              <v-col cols="2" align="end" class="pa-0 ma-0">
                <v-btn :disabled="userFavSongs.length > 149" v-if="this.notinFav(mus.id)" icon="mdi-star-outline"
                  class="pt-4" :ripple="false" density="compact" size="small" variant="plain"
                  style="color: white !important" @click="this.addToFav(mus)">
                </v-btn>
                <v-btn v-else icon="mdi-star" class="pt-4" :ripple="false" density="compact" size="small" variant="plain"
                  style="color: #f0e556 !important" @click="this.removeFromFav(mus)">
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>

          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">NFT
                <a :href="'https://muze.muzible.com/search/nft?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <div v-if="userSearchResults.nfts && userSearchResults.nfts.length > 0" class="pa-0 ma-0" justify="start">
            <v-row class="pa-2 ma-0" v-for="mus in userSearchResults.nfts" :key="mus.id">
              <v-col cols="2" class="pa-0 ma-0">
                <v-hover>
                  <template v-slot:default="{ isHovering, props }">
                    <div v-bind="props" class="pa-0 ma-0">
                      <v-img :src="mus.art" @click="this.playOrPauseSong(mus)" class="album-art-row" contain cover max-height="60px" max-width="60px">
                        <v-icon v-if="
                          isHovering &&
                          this.ifCurrentMusicNow(mus) &&
                          this.isPlayingNow(mus)
                        " class="overlay-icon" color="white" size="60px">mdi-pause</v-icon>
                        <v-icon v-if="
                          isHovering &&
                          this.ifCurrentMusicNow(mus) &&
                          !this.isPlayingNow(mus)
                        " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                        <v-icon v-if="
                          isHovering &&
                          !this.ifCurrentMusicNow(mus)
                        " class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                        <v-icon v-if="
                          !isHovering &&
                          this.isPlayingNow(mus)
                        " class="music-icon" color="#1ff050" size="60px">mdi-music</v-icon>

                      </v-img>
                    </div>
                  </template>
                </v-hover>
              </v-col>
              <v-col cols="6" class="pa-0 ma-0 pl-5">
                <div class="track-info">
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 200px;
                            ">
                    <a v-if="mus.type === 'muze' && mus.album === ''" :href="'https://muze.muzible.com/track/' + mus.id"
                      class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'muze' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' + mus.id"
                      class="artist-link">{{
                      mus.title }}</a>
                    <a v-if="mus.type === 'geo'" :href="'https://verse.muzible.com/track/' + mus.id"
                      class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'global' && mus.album === ''" :href="'https://muze.muzible.com/track/' + mus.id"
                      class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'global' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album === ''"
                      :href="'https://muze.muzible.com/episode/' + mus.id" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album !== ''"
                      :href="'https://muze.muzible.com/podcast/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                  </div>
                  <div style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 200px;
                            ">
                    <span v-for="(artist, index) in mus.artists" :key="index">
                      <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist
                        }}</a>
                      <span v-if="index < mus.artists.length - 1">, </span>
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col cols="2" align="end" class="pa-0 ma-0">
                  <div class="track-info pt-4">
                    <span style="color: grey;">{{ mus.duration }}</span>
                  </div>
              </v-col>
              <v-col cols="2" align="end" class="pa-0 ma-0">
                <v-btn :disabled="userFavSongs.length > 149" v-if="this.notinFav(mus.id)" icon="mdi-star-outline"
                  class="pt-4" :ripple="false" density="compact" size="small" variant="plain"
                  style="color: white !important" @click="this.addToFav(mus)">
                </v-btn>
                <v-btn v-else icon="mdi-star" class="pt-4" :ripple="false" density="compact" size="small" variant="plain"
                  style="color: #f0e556 !important" @click="this.removeFromFav(mus)">
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>

          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">Playlists
                <a :href="'https://muze.muzible.com/search/playlist?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <div v-if="userSearchResults.playlists && userSearchResults.playlists.length > 0" class="pa-0 ma-0" justify="start">
            <v-row class="pa-2 ma-0" v-for="mus in userSearchResults.playlists" :key="mus.id">
              <v-col cols="2" class="pa-0 ma-0">
                <v-hover>
                  <template v-slot:default="{ isHovering, props }">
                    <div v-bind="props" class="pa-0 ma-0">
                      <v-img :src="mus.src" @click="this.addFullTracksToPlay(mus)" class="album-art-row" contain cover max-height="60px" max-width="60px">
                        <v-icon v-if="isHovering" class="overlay-icon" color="white" size="60px">mdi-playlist-play</v-icon>
                      </v-img>
                    </div>
                  </template>
                </v-hover>
              </v-col>
              <v-col cols="6" class="pa-0 ma-0 pl-5">
                <div class="track-info">
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 200px;
                            ">
                    <a :href="'https://muze.muzible.com/playlist/' + mus.id" class="artist-link">{{ mus.name }}</a>
                  </div>
                  <div style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 200px;
                            ">
                    <span>
                      <a :href="'https://muze.muzible.com/creator/' + mus.creator" class="artist-link">{{ mus.creator }}</a>
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col cols="4" align="center" class="pa-0 ma-0">
                  <div class="track-info pt-4">
                    <span style="color: grey;">Tracks: {{ mus.tracks.length }}</span>
                  </div>
              </v-col>
            </v-row>
          </div>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>



          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">Albums
                <a :href="'https://muze.muzible.com/search/album?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <div v-if="userSearchResults.albums && userSearchResults.albums.length > 0" class="pa-0 ma-0" justify="start">
            <v-row class="pa-2 ma-0" v-for="mus in userSearchResults.albums" :key="mus.id">
              <v-col cols="2" class="pa-0 ma-0">
                <v-hover>
                  <template v-slot:default="{ isHovering, props }">
                    <div v-bind="props" class="pa-0 ma-0">
                      <v-img :src="mus.art" @click="this.addFullAlbumToPlay(mus)" class="album-art-row" contain cover max-height="60px" max-width="60px">
                        <v-icon v-if="isHovering" class="overlay-icon" color="white" size="60px">mdi-playlist-play</v-icon>
                      </v-img>
                    </div>
                  </template>
                </v-hover>
              </v-col>
              <v-col cols="6" class="pa-0 ma-0 pl-5">
                <div class="track-info">
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 200px;
                            ">
                    <a :href="'https://muze.muzible.com/album/' + mus.id"
                      class="artist-link">{{ mus.name
                      }}</a>
                  </div>
                  <div style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 200px;
                            ">
                    <span v-for="(artist, index) in mus.artists" :key="index">
                      <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist
                        }}</a>
                      <span v-if="index < mus.artists.length - 1">, </span>
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col cols="4" align="center" class="pa-0 ma-0">
                  <div class="track-info pt-4">
                    <span style="color: grey;">Tracks: {{ mus.tracks.length }}</span>
                  </div>
              </v-col>
            </v-row>
          </div>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>

          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">Artists
                <a :href="'https://muze.muzible.com/search/artist?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <div v-if="userSearchResults.artists && userSearchResults.artists.length > 0" class="pa-0 ma-0" justify="start">
            <v-row class="pa-2 ma-0" v-for="mus in userSearchResults.artists" :key="mus.id">
              <v-col cols="2" class="pa-0 ma-0">
                <v-hover>
                  <template v-slot:default="{ isHovering, props }">
                    <div v-bind="props" class="pa-0 ma-0">
                      <v-img :src="mus.art" @click="this.addFullArtistToQueue(mus)" class="album-art-row" contain cover max-height="60px" max-width="60px">
                        <v-icon v-if="isHovering" class="overlay-icon" color="white" size="60px">mdi-play</v-icon>

                      </v-img>
                    </div>
                  </template>
                </v-hover>
              </v-col>
              <v-col cols="10" class="pa-0 ma-0 pl-5 pt-4">
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 260px;
                            ">
                    <a :href="'https://muze.muzible.com/artist/' + mus.id"
                      class="artist-link">{{ mus.name }}</a>
                  </div>
              </v-col>
            </v-row>
          </div>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>

          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">MuzE Creators
                <a :href="'https://muze.muzible.com/search/creator?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <div v-if="userSearchResults.creators && userSearchResults.creators.length > 0" class="pa-0 ma-0" justify="start">
            <v-row class="pa-2 ma-0" v-for="mus in userSearchResults.creators" :key="mus.id">
              <v-col cols="2" class="pa-0 ma-0">
                <v-hover>
                  <template v-slot:default="{ isHovering, props }">
                    <div v-bind="props" class="pa-0 ma-0">
                      <v-img :src="mus.art" @click="this.addFullCreatorToQueue(mus)" class="album-art-row" contain cover max-height="60px" max-width="60px">
                        <v-icon v-if="isHovering" class="overlay-icon" color="white" size="60px">mdi-play</v-icon>
                      </v-img>
                    </div>
                  </template>
                </v-hover>
              </v-col>
              <v-col cols="10" class="pa-0 ma-0 pl-5 pt-4">
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 260px;
                            ">
                    <a :href="'https://muze.muzible.com/creator/' + mus.id" class="artist-link">{{ mus.name }}</a>
                  </div>
              </v-col>
            </v-row>
          </div>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>

        </div>
        <!-- Wyświetlanie dla rozmiarów sm i większych -->
        <div v-else>
          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
                <div style="color: white; font-size: 24px; font-weight: bold;">
                Music
                <a :href="'https://muze.muzible.com/search/music?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
                </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <v-row v-if="userSearchResults.songs && userSearchResults.songs.length > 0" class="pa-0 ma-0" justify="start">
            <v-col class="pa-2 ma-0" v-for="mus in userSearchResults.songs" :key="mus.id" cols="12" sm="3" md="2" lg="2"
              xl="1" align="center">
              <div class="playlist-card">
                <div class="track-info">
                  <v-hover>
                      <template v-slot:default="{ isHovering, props }">
                        <div v-bind="props" class="pa-0 ma-0">
                          <v-img :src="mus.art" cover class="album-art">

                            <v-icon v-if="
                                isHovering &&
                                this.ifCurrentMusicNow(mus) &&
                                this.isPlayingNow(mus)
                              " class="overlay-icon-round" color="white"  @click="this.playOrPauseSong(mus)" size="60px">mdi-pause</v-icon>
                              <v-icon v-if="
                                isHovering &&
                                this.ifCurrentMusicNow(mus) &&
                                !this.isPlayingNow(mus)
                              " class="overlay-icon-round" color="white"  @click="this.playOrPauseSong(mus)" size="60px">mdi-play</v-icon>
                              <v-icon v-if="
                                isHovering &&
                                !this.ifCurrentMusicNow(mus)
                              " class="overlay-icon-round" color="white"  @click="this.playOrPauseSong(mus)" size="60px">mdi-play</v-icon>
                              <v-icon v-if="
                                !isHovering &&
                                this.isPlayingNow(mus)
                              " class="overlay-icon-round-music" color="#1ff050" size="60px">mdi-music</v-icon>


                            <div class="div-back">
                              <div class="track-info-row pt-1">
                                
                                <span style="color: white;">{{ mus.duration }}</span>
                                  <v-btn :disabled="userFavSongs.length > 149" v-if="this.notinFav(mus.id)" icon="mdi-star-outline"
                                    class="img-btn-loc" :ripple="false" density="compact" size="small" variant="plain"
                                    style="color: white !important" @click="this.addToFav(mus)">
                                  </v-btn>
                                  <v-btn v-else icon="mdi-star" class="img-btn-loc" :ripple="false" density="compact" size="small" variant="plain"
                                    style="color: #f0e556 !important" @click="this.removeFromFav(mus)">
                                  </v-btn>
                            </div>
                            </div>

                          </v-img>
                        </div>                  
                     </template>
                  </v-hover>
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <a v-if="mus.type === 'muze' && mus.album === ''" :href="'https://muze.muzible.com/track/' + mus.id"
                      class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'muze' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' + mus.id"
                      class="artist-link">{{ mus.title }}</a>
                    <a v-if="mus.type === 'geo'" :href="'https://verse.muzible.com/track/' + mus.id"
                      class="artist-link">{{
                      mus.title }}</a>
                    <a v-if="mus.type === 'global' && mus.album === ''"
                      :href="'https://muze.muzible.com/track/' + mus.id" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'global' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album === ''"
                      :href="'https://muze.muzible.com/episode/' + mus.id" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album !== ''"
                      :href="'https://muze.muzible.com/podcast/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                  </div>
                  <div style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <span v-for="(artist, index) in mus.artists" :key="index">
                      <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist
                        }}</a>
                      <span v-if="index < mus.artists.length - 1">, </span>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>


          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">Podcasts
                <a :href="'https://muze.muzible.com/search/podcast?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <v-row v-if="userSearchResults.podcasts && userSearchResults.podcasts.length > 0" class="pa-0 ma-0" justify="start">
            <v-col class="pa-2 ma-0" v-for="mus in userSearchResults.podcasts" :key="mus.id" cols="12" sm="3" md="2" lg="2"
              xl="1" align="center">
              <div class="playlist-card">
                <div class="track-info">
                  <v-hover>
                      <template v-slot:default="{ isHovering, props }">
                        <div v-bind="props" class="pa-0 ma-0">
                          <v-img :src="mus.art" cover class="album-art">

                            <v-icon v-if="
                                isHovering &&
                                this.ifCurrentMusicNow(mus) &&
                                this.isPlayingNow(mus)
                              " class="overlay-icon-round" color="white"  @click="this.playOrPauseSong(mus)" size="60px">mdi-pause</v-icon>
                              <v-icon v-if="
                                isHovering &&
                                this.ifCurrentMusicNow(mus) &&
                                !this.isPlayingNow(mus)
                              " class="overlay-icon-round" color="white"  @click="this.playOrPauseSong(mus)" size="60px">mdi-play</v-icon>
                              <v-icon v-if="
                                isHovering &&
                                !this.ifCurrentMusicNow(mus)
                              " class="overlay-icon-round" color="white"  @click="this.playOrPauseSong(mus)" size="60px">mdi-play</v-icon>
                              <v-icon v-if="
                                !isHovering &&
                                this.isPlayingNow(mus)
                              " class="overlay-icon-round-music" color="#1ff050" size="60px">mdi-music</v-icon>


                            <div class="div-back">
                              <div class="track-info-row pt-1">
                                
                                <span style="color: white;">{{ mus.duration }}</span>
                                  <v-btn :disabled="userFavSongs.length > 149" v-if="this.notinFav(mus.id)" icon="mdi-star-outline"
                                    class="img-btn-loc" :ripple="false" density="compact" size="small" variant="plain"
                                    style="color: white !important" @click="this.addToFav(mus)">
                                  </v-btn>
                                  <v-btn v-else icon="mdi-star" class="img-btn-loc" :ripple="false" density="compact" size="small" variant="plain"
                                    style="color: #f0e556 !important" @click="this.removeFromFav(mus)">
                                  </v-btn>
                            </div>
                            </div>

                          </v-img>
                        </div>                  
                     </template>
                  </v-hover>
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <a v-if="mus.type === 'muze' && mus.album === ''" :href="'https://muze.muzible.com/track/' + mus.id"
                      class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'muze' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' + mus.id"
                      class="artist-link">{{ mus.title }}</a>
                    <a v-if="mus.type === 'geo'" :href="'https://verse.muzible.com/track/' + mus.id"
                      class="artist-link">{{
                      mus.title }}</a>
                    <a v-if="mus.type === 'global' && mus.album === ''"
                      :href="'https://muze.muzible.com/track/' + mus.id" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'global' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album === ''"
                      :href="'https://muze.muzible.com/episode/' + mus.id" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album !== ''"
                      :href="'https://muze.muzible.com/podcast/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                  </div>
                  <div style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <span v-for="(artist, index) in mus.artists" :key="index">
                      <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist
                        }}</a>
                      <span v-if="index < mus.artists.length - 1">, </span>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>


          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">Geo Music
                <a :href="'https://muze.muzible.com/search/geo?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <v-row v-if="userSearchResults.geo && userSearchResults.geo.length > 0" class="pa-0 ma-0" justify="start">
            <v-col class="pa-2 ma-0" v-for="mus in userSearchResults.geo" :key="mus.id" cols="12" sm="3" md="2" lg="2"
              xl="1" align="center">
              <div class="playlist-card">
                <div class="track-info">
                  <v-hover>
                      <template v-slot:default="{ isHovering, props }">
                        <div v-bind="props" class="pa-0 ma-0">
                          <v-img :src="mus.art" cover class="album-art">

                            <v-icon v-if="
                                isHovering &&
                                this.ifCurrentMusicNow(mus) &&
                                this.isPlayingNow(mus)
                              " class="overlay-icon-round" color="white"  @click="this.playOrPauseSong(mus)" size="60px">mdi-pause</v-icon>
                              <v-icon v-if="
                                isHovering &&
                                this.ifCurrentMusicNow(mus) &&
                                !this.isPlayingNow(mus)
                              " class="overlay-icon-round" color="white"  @click="this.playOrPauseSong(mus)" size="60px">mdi-play</v-icon>
                              <v-icon v-if="
                                isHovering &&
                                !this.ifCurrentMusicNow(mus)
                              " class="overlay-icon-round" color="white"  @click="this.playOrPauseSong(mus)" size="60px">mdi-play</v-icon>
                              <v-icon v-if="
                                !isHovering &&
                                this.isPlayingNow(mus)
                              " class="overlay-icon-round-music" color="#1ff050" size="60px">mdi-music</v-icon>


                            <div class="div-back">
                              <div class="track-info-row pt-1">
                                <v-btn icon="mdi-earth"
                                    class="img-btn-loc-front" :ripple="false" density="compact" size="small" variant="plain"
                                    style="color: white !important" @click="this.openGeoLink(mus.geo_link)">
                                  </v-btn>
                                <span style="color: white;">{{ mus.duration }}</span>
                                  <v-btn :disabled="userFavSongs.length > 149" v-if="this.notinFav(mus.id)" icon="mdi-star-outline"
                                    class="img-btn-loc" :ripple="false" density="compact" size="small" variant="plain"
                                    style="color: white !important" @click="this.addToFav(mus)">
                                  </v-btn>
                                  <v-btn v-else icon="mdi-star" class="img-btn-loc" :ripple="false" density="compact" size="small" variant="plain"
                                    style="color: #f0e556 !important" @click="this.removeFromFav(mus)">
                                  </v-btn>
                            </div>
                            </div>

                          </v-img>
                        </div>                  
                     </template>
                  </v-hover>
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <a v-if="mus.type === 'muze' && mus.album === ''" :href="'https://muze.muzible.com/track/' + mus.id"
                      class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'muze' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' + mus.id"
                      class="artist-link">{{ mus.title }}</a>
                    <a v-if="mus.type === 'geo'" :href="'https://verse.muzible.com/track/' + mus.id"
                      class="artist-link">{{
                      mus.title }}</a>
                    <a v-if="mus.type === 'global' && mus.album === ''"
                      :href="'https://muze.muzible.com/track/' + mus.id" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'global' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album === ''"
                      :href="'https://muze.muzible.com/episode/' + mus.id" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album !== ''"
                      :href="'https://muze.muzible.com/podcast/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                  </div>
                  <div style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <span v-for="(artist, index) in mus.artists" :key="index">
                      <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist
                        }}</a>
                      <span v-if="index < mus.artists.length - 1">, </span>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>



          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">NFT
                <a :href="'https://muze.muzible.com/search/nft?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <v-row v-if="userSearchResults.nfts && userSearchResults.nfts.length > 0" class="pa-0 ma-0" justify="start">
            <v-col class="pa-2 ma-0" v-for="mus in userSearchResults.nfts" :key="mus.id" cols="12" sm="3" md="2" lg="2"
              xl="1" align="center">
              <div class="playlist-card">
                <div class="track-info">
                  <v-hover>
                      <template v-slot:default="{ isHovering, props }">
                        <div v-bind="props" class="pa-0 ma-0">
                          <v-img :src="mus.art" cover class="album-art">

                            <v-icon v-if="
                                isHovering &&
                                this.ifCurrentMusicNow(mus) &&
                                this.isPlayingNow(mus)
                              " class="overlay-icon-round" color="white"  @click="this.playOrPauseSong(mus)" size="60px">mdi-pause</v-icon>
                              <v-icon v-if="
                                isHovering &&
                                this.ifCurrentMusicNow(mus) &&
                                !this.isPlayingNow(mus)
                              " class="overlay-icon-round" color="white"  @click="this.playOrPauseSong(mus)" size="60px">mdi-play</v-icon>
                              <v-icon v-if="
                                isHovering &&
                                !this.ifCurrentMusicNow(mus)
                              " class="overlay-icon-round" color="white"  @click="this.playOrPauseSong(mus)" size="60px">mdi-play</v-icon>
                              <v-icon v-if="
                                !isHovering &&
                                this.isPlayingNow(mus)
                              " class="overlay-icon-round-music" color="#1ff050" size="60px">mdi-music</v-icon>


                            <div class="div-back">
                              <div class="track-info-row pt-1">
                                
                                <span style="color: white;">{{ mus.duration }}</span>
                                  <v-btn :disabled="userFavSongs.length > 149" v-if="this.notinFav(mus.id)" icon="mdi-star-outline"
                                    class="img-btn-loc" :ripple="false" density="compact" size="small" variant="plain"
                                    style="color: white !important" @click="this.addToFav(mus)">
                                  </v-btn>
                                  <v-btn v-else icon="mdi-star" class="img-btn-loc" :ripple="false" density="compact" size="small" variant="plain"
                                    style="color: #f0e556 !important" @click="this.removeFromFav(mus)">
                                  </v-btn>
                            </div>
                            </div>

                          </v-img>
                        </div>                  
                     </template>
                  </v-hover>
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <a v-if="mus.type === 'muze' && mus.album === ''" :href="'https://muze.muzible.com/track/' + mus.id"
                      class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'muze' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'ticket'" :href="'https://tickets.muzible.com/ticket/' + mus.id"
                      class="artist-link">{{ mus.title }}</a>
                    <a v-if="mus.type === 'geo'" :href="'https://verse.muzible.com/track/' + mus.id"
                      class="artist-link">{{
                      mus.title }}</a>
                    <a v-if="mus.type === 'global' && mus.album === ''"
                      :href="'https://muze.muzible.com/track/' + mus.id" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'global' && mus.album !== ''"
                      :href="'https://muze.muzible.com/album/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album === ''"
                      :href="'https://muze.muzible.com/episode/' + mus.id" class="artist-link">{{ mus.title
                      }}</a>
                    <a v-if="mus.type === 'podcast' && mus.album !== ''"
                      :href="'https://muze.muzible.com/podcast/' + mus.album" class="artist-link">{{ mus.title
                      }}</a>
                  </div>
                  <div style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <span v-for="(artist, index) in mus.artists" :key="index">
                      <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist
                        }}</a>
                      <span v-if="index < mus.artists.length - 1">, </span>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>


          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">Playlists
                <a :href="'https://muze.muzible.com/search/playlist?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <v-row v-if="userSearchResults.playlists && userSearchResults.playlists.length > 0" class="pa-0 ma-0" justify="start">
            <v-col class="pa-2 ma-0" v-for="mus in userSearchResults.playlists" :key="mus.id" cols="12" sm="3" md="2" lg="2"
              xl="1" align="center">
              <div class="playlist-card">
                <div class="track-info">
                  <v-hover>
                      <template v-slot:default="{ isHovering, props }">
                        <div v-bind="props" class="pa-0 ma-0">
                          <v-img :src="mus.src" cover class="album-art">

                              <v-icon v-if="isHovering" class="overlay-icon-round" 
                                color="white"  
                                @click="this.addFullTracksToPlay(mus)" size="60px">mdi-playlist-play</v-icon>

                            <div class="div-back">
                              <div class="track-info-row pt-1">                                
                                <span style="color: white;">Tracks: {{ mus.tracks.length }}</span>
                              </div>
                            </div>
                          </v-img>
                        </div>                  
                     </template>
                  </v-hover>
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <a :href="'https://muze.muzible.com/playlist/' + mus.id"
                      class="artist-link">{{ mus.name }}</a>
                  </div>
                  <div style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <span>
                      <a :href="'https://muze.muzible.com/creator/' + mus.creator" class="artist-link">{{ mus.creator}}</a>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>


          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">Albums
                <a :href="'https://muze.muzible.com/search/album?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <v-row v-if="userSearchResults.albums && userSearchResults.albums.length > 0" class="pa-0 ma-0" justify="start">
            <v-col class="pa-2 ma-0" v-for="mus in userSearchResults.albums" :key="mus.id" cols="12" sm="3" md="2" lg="2"
              xl="1" align="center">
              <div class="playlist-card">
                <div class="track-info">
                  <v-hover>
                      <template v-slot:default="{ isHovering, props }">
                        <div v-bind="props" class="pa-0 ma-0">
                          <v-img :src="mus.art" cover class="album-art">

                              <v-icon v-if="isHovering" class="overlay-icon-round" 
                                      color="white"  @click="this.addFullAlbumToPlay(mus)" size="60px">mdi-playlist-play</v-icon>

                            <div class="div-back">
                              <div class="track-info-row pt-1">                                
                                <span style="color: white;">Tracks: {{ mus.tracks.length }}</span>
                              </div>
                            </div>
                          </v-img>
                        </div>                  
                     </template>
                  </v-hover>
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <a :href="'https://muze.muzible.com/album/' + mus.id" class="artist-link">{{ mus.name }}</a>                   
                  </div>
                  <div style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <span v-for="(artist, index) in mus.artists" :key="index">
                      <a :href="'https://muze.muzible.com/search/artist?name=' + artist" class="artist-link">{{ artist }}</a>
                      <span v-if="index < mus.artists.length - 1">, </span>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>



          
          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">Artists
                <a :href="'https://muze.muzible.com/search/artist?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <v-row v-if="userSearchResults.artists && userSearchResults.artists.length > 0" class="pa-0 ma-0" justify="start">
            <v-col class="pa-2 ma-0" v-for="mus in userSearchResults.artists" :key="mus.id" cols="12" sm="3" md="2" lg="2"
              xl="1" align="center">
              <div class="playlist-card">
                <div class="track-info">
                  <v-hover>
                      <template v-slot:default="{ isHovering, props }">
                        <div v-bind="props" class="pa-0 ma-0">
                          <v-img :src="mus.art" cover class="album-art">
                              <v-icon v-if="isHovering" class="overlay-icon-round" 
                              color="white"  
                              @click="this.addFullArtistToQueue(mus)" size="60px">mdi-play</v-icon>
                          </v-img>
                        </div>                  
                     </template>
                  </v-hover>
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <span>
                      <a :href="'https://muze.muzible.com/artist/' + mus.id" class="artist-link">{{ mus.name }}</a>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>



          <v-row class="pa-0 ma-0" justify="center">
            <v-col cols="12" class="pa-2 ma-0" align="start">
              <div style="color: white; font-size: 24px; font-weight: bold;">MuzE Creators
                <a :href="'https://muze.muzible.com/search/creator?name=' + searchQuery" class="search-title" style="font-weight: normal; margin-left: 10px;">
                  Search all
                </a>
              </div>
            </v-col>
            <v-divider class="pa-2 ma-0" style="color:white;"></v-divider>
          </v-row>
          <v-row v-if="userSearchResults.creators && userSearchResults.creators.length > 0" class="pa-0 ma-0" justify="start">
            <v-col class="pa-2 ma-0" v-for="mus in userSearchResults.creators" :key="mus.id" cols="12" sm="3" md="2" lg="2"
              xl="1" align="center">
              <div class="playlist-card">
                <div class="track-info">
                  <v-hover>
                      <template v-slot:default="{ isHovering, props }">
                        <div v-bind="props" class="pa-0 ma-0">
                          <v-img :src="mus.art" cover class="album-art">
                              <v-icon v-if="isHovering" class="overlay-icon-round" 
                              color="white"  
                              @click="this.addFullCreatorToQueue(mus)" size="60px">mdi-play</v-icon>
                          </v-img>
                        </div>                  
                     </template>
                  </v-hover>
                  <div class="track-title" style="
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 180px;
                            ">
                    <span>
                      <a :href="'https://muze.muzible.com/creator/' + mus.id" class="artist-link">{{ mus.name }}</a>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row v-else class="pa-0 ma-0" justify="center">
            <v-col class="pa-2 ma-0" align="center">
              <div style="color: grey; font-size: 24px; font-weight: bold;">No results found</div>
            </v-col>
          </v-row>

        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { useMobile } from '../composables/useMobile.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { useMobileSm } from '../composables/useMobileSm.js'
import { useMobileSearch1 } from "../composables/useMobileSearch1.js";
import { useMobileSearch2 } from "../composables/useMobileSearch2.js";
import { useMobilePlayer3 } from "../composables/useMobilePlayer3.js";

export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobileSm = useMobileSm()
    const isMobileSearch1 = useMobileSearch1()
    const isMobileSearch2 = useMobileSearch2()
    const isMobilePlayer3 = useMobilePlayer3()

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };
    return { notify, notifyError, isMobile, isMobileXs, isMobileSm, isMobileSearch1, isMobileSearch2, isMobilePlayer3 };
  },
  data() {
    return {
      searchQuery: "",
      filter: ["all"],
      isSearchLoading: true,
      showFilter: false,

    };
  },
  computed: {
    user() {
      return this.$store.getters.getUserData;
    },
    userSearchResults() {
      return this.$store.getters.getUserSearchResults;
    },
    userFavSongs() {
      return this.$store.getters.getUserFavSongs;
    },
    isPlaying() {
      return this.$store.getters.getIsPlaying;
    },
    tracks() {
      return this.$store.getters.getUserCurrentSongs;
    },
    currentTrack() {
      if (this.tracks.length === 0) {
        return this.$store.getters.getDefaultCurrentSong[0];
      }
      return this.tracks[this.currentTrackIndex];
    },
    currentTrackIndex() {
      return this.$store.getters.getCurrentTrackIndex;
    },
  },
  methods: {
    handleFilterChange(newfilter) {
      if (newfilter[newfilter.length - 1] === 'all') {
        this.filter = ['all'];
      } else if (this.filter.length === 0) {
        this.filter = ['all'];
      } else if (this.filter.length > 1 && this.filter.includes('all')) {
        this.filter = this.filter.filter(f => f !== 'all');
      }
    },
    openGeoLink(link) {
      window.open(link, '_blank');
    },
    notinFav(id) {
      for (let i = 0; i < this.userFavSongs.length; i++) {
        if (this.userFavSongs[i].id === id) {
          return false;
        }
      }
      return true;
    },
    playHLScheck(track) {
      if (track.hlssrc !== "") {
        return true;
      } else {
        return false;
      }
    },
    removeFromFav(track) {
      this.emitter.emit("removeFromFav", track);
    },
    addToFav(track) {
      this.emitter.emit("addToFav", track);
    },
    playOrPauseSong(track) {
      this.emitter.emit("playOrPauseSong", track);
    },
    addFullTracksToPlay(pl) {
      this.emitter.emit("addFullTracksToPlay", pl);
    },
    addFullAlbumToPlay(album) {
      this.emitter.emit("addFullAlbumToPlay", album);
    },
    addFullArtistToQueue(artist) {
      this.emitter.emit("addFullArtistToQueue", artist.id);
    },
    addFullCreatorToQueue(creator) {
      this.emitter.emit("addFullCreatorToQueue", creator.id);
    },
    ifCurrentMusicNow(track) {
      if (this.currentTrack.id === track.id) {
        return true;
      }
      return false;
    },
    isPlayingNow(fav) {
      if (this.currentTrack.id === fav.id && this.isPlaying) {
        return true;
      }
      return false;
    },

  },
  watch: {},
  created() {
    if (this.user != null) {
      // Get Query Search - initial search based on last search query when searchQWuery is Empty

      if (this.userSearchResults && this.userSearchResults.songs.length !== 0) {
        this.isSearchLoading = false;
      } else {
        this.$store.dispatch("getQuerySearch", {
          token: this.user.token,
          query: this.searchQuery,
          filter: this.filter,
        }).then(() => {
          setTimeout(() => {
            this.isSearchLoading = false;
          }, 1000);
        });
      }
    }
  },
  mounted() {

  },
  beforeDestroy() {

  },
};
</script>

<style lang="scss" scoped>
@use "/src/views/css/styles.scss";

.playlist-row {
  display: flex;
  align-items: center;
}

.img-btn-loc {
  position: absolute;
  bottom: -4px;
  right: 0;
}
  
  .img-btn-loc-front {
    position: absolute;
    bottom: -4px;
    left: 0;
  }

.div-back {
  background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 33px;
  bottom: 0;
  left:0;
  position: absolute;
}

.album-art-row {
  width: 60px;
  height: 60px;
  aspect-ratio: 1/1;
  border-radius: 5px!important;
  margin-right: 10px;
  border: 1px solid transparent;
}

.album-art-row:hover {
  cursor: pointer;
  filter: brightness(1.3);
  border: 1px solid white;
  border-radius: 5px;
}

.track-info-row {
  color: white;
  flex: 1;
}


.track-artist {
  color: grey !important;
}

.music-search-container {
  height: calc(100dvh - 83px);
}

.content-container {
  height: calc(100% - 120px);
  overflow-y: auto;
}

.content-container-mobile {
  height: calc(100% - 161px);
  overflow-y: auto;
}

.content-container2 {
  height: calc(100% - 124px);
  overflow-y: auto;
}

.content-container2-mobile {
  height: calc(100% - 165px);
  overflow-y: auto;
}

.content-container1 {
  height: calc(100% - 210px);
  overflow-y: auto;
}

.content-container1-mobile {
  height: calc(100% - 251px);
  overflow-y: auto;
}

.content-container4 {
  height: calc(100% - 210px);
  overflow-y: auto;
}

.content-container4-mobile {
  height: calc(100% - 251px);
  overflow-y: auto;
}

.content-container3 {
  height: calc(100% - 248px);
  overflow-y: auto;
}

.content-container3-mobile {
  height: calc(100% - 289px);
  overflow-y: auto;
}

.custom-placeholder-color input::placeholder {
  color: white !important;
  opacity: 1;
}

.playlist-card {
  background-color: black !important;
  border-radius: 8px !important;
  border: 1px solid transparent !important;
}

.playlist-card-pl {
  background-color: black !important;
  border-radius: 8px !important;
  border: 1px solid transparent !important;
}

.playlist-card-fav {
  background-color: black !important;
  border-radius: 8px !important;
  border: 1px solid transparent !important;
}

.playlist-card-tracks {
  background-color: black !important;
  border-radius: 8px !important;
  border: 1px solid transparent !important;
}

.playlist-card-noplay {
  cursor: default !important;
  background-color: black !important;
  border-radius: 8px !important;
  border: 1px solid transparent !important;
}

.music-player {
  background-color: transparent;
  color: white;
}

.chip-style {
  background-color: black !important;
  color: white !important;
  border: 1px solid transparent !important;
}

.chip-style:hover {
  background-color: black !important;
  color: white !important;
  border: 1px solid white !important;
}

.chip-style-nft {
  background-color: rgba(177, 106, 191, 0.333) !important;
  color: white !important;
  border: 1px solid transparent !important;
}

.chip-style-nft:hover {
  background-color: rgba(177, 106, 191, 0.333) !important;
  color: white !important;
  border: 1px solid white !important;
}

.v-chip--selected {
  background-color: inherit!important;
  color: white !important;
  border: 1px solid white !important;
}

.artist-link {
  color: white;
  text-decoration: none;
  font-size: 15px;
}

.artist-link:hover {
  color: white;
  text-decoration: underline;
  text-decoration-color: white;
}

.album-art {
  border-radius: 5px !important;
  border: 1px solid transparent !important;
  max-width: 200px;
  max-height: 200px;
  aspect-ratio: 1/1;
}

.album-art2 {
  border-radius: 5px !important;
}

.track-info {
  color: white;
  font-size: 15px;
}

.track-title {
  color: white;
  font-weight: bold;
  font-size: 16px;
}

.search-title {
  font-size: 16px;
  cursor: pointer;
  color: white;
  text-decoration: underline;
  text-decoration-color: white;
}

.search-title:hover {
  font-size: 16px;
  cursor: pointer;
  color: white;
  text-decoration: none;
  text-decoration-color: white;
}

.track-artist {
  font-size: 16px;
  color: gray;
}

.progress-bar {
  margin-top: 0px;
}

.time-info {
  font-size: 0.8em;
}

.bottom-right-icon {
  position: absolute;
  color: black;
}

.album-art:hover {
  cursor: pointer !important;
  filter: brightness(1.3) !important;
  border: 1px solid white !important;
  border-radius: 5px;
}

.v-card-text {
  padding: 0px !important;
}

.overlay-pl {
  position: relative;
  width: 120px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  opacity: 1;
  border: 0px solid black;
  height: 24px;
}

.overlay-text-pl {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: bold !important;
  text-align: center;
}

.overlay-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.8);
  /* Optional: add a background */
  padding: 0px;
  margin: 0px;
  border-radius: 0px !important;
}

.overlay-icon:hover {
  cursor: pointer !important;
  border: 1px solid white !important;
  border-radius: 5px !important;
}

.overlay-icon-round {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.8);
  /* Optional: add a background */
  padding: 0px;
  margin: 0px;
  border-radius: 50px !important;
}

.overlay-icon-round:hover {
  cursor: pointer !important;
  border: 1px solid white !important;
  border-radius: 50px !important;
}

.overlay-icon-round-music {
  position: absolute;
  top: 50%;
  left: 50%;
  animation: pulsesec 0.6s infinite;
  background-color: rgba(0, 0, 0, 0.8);
  /* Optional: add a background */
  padding: 0px;
  margin: 0px;
  border-radius: 50px !important;
}

.overlay-icon-round-music:hover {
  cursor: pointer !important;
  border: 1px solid white !important;
  border-radius: 50px !important;
}

.music-icon2 {
  animation: pulse 0.6s infinite;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  /* Optional: add a background */
  padding: 0px;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  margin: 0px;
  border-radius: 50px!important;
}

.music-icon2:hover {
  cursor: pointer !important;
  border: 1px solid white !important;
  border-radius: 50px !important;
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }
}

@keyframes pulsesec {

  0% {
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}

.music-icon {
  animation: pulse 0.6s infinite;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  /* Optional: add a background */
  padding: 0px;
  margin: 0px;
  border-radius: 5px;
}

.simple-icon:hover {
  cursor: pointer;
  filter: brightness(1.2);
  transform: scale(1.2);
}

.loading-spinner {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  background-color: transparent;
}

.fade2-enter-active,
.fade2-leave-active {
  transition: opacity 0.3s ease !important;
}

.fade2-enter-from,
.fade2-leave-to {
  opacity: 0 !important;
}
</style>
